
import Visual from 'vue-visual'

export default
	components: { Visual }
	props: block: Object

	computed:
		classes: -> [@block.maxWidth || "max-w-wide-indented", 'has-heading' if @block.heading]

		style: ->
			"--grid-template-columns": "repeat(#{@block.icons.length}, 1fr)"

	methods:
		# Make gif url
		getImage: (image) ->
			return unless image.length
			imgixUrl = process.env.IMGIX_URL
			if imgixUrl then "#{imgixUrl}/#{image[0].path}"
			else image[0].url

